module.exports = __webpack_public_path__ + "img/task_group_guys.fac5cdd2.png";